import { Component, Input,  OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from '../../Services/shared-data/shared-data.service';

@Component({
  selector: 'paflabel',
  templateUrl: './paflabel.component.html',
  styleUrls: ['./paflabel.component.scss']
})
export class PafLabelComponent implements OnInit, OnChanges {
  @Input() lblCod:string;

  label : string='';

  
  constructor(
    private route: ActivatedRoute,
    public sharedDataSvc: SharedDataService) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lblCod']){
      this.updateLabel();
    }
  }

  ngOnInit(): void {    
    this.updateLabel();
    this.sharedDataSvc.langChanged.subscribe(res=>this.updateLabel());    
  }

  

  updateLabel():void{
    this.sharedDataSvc.getLabel(this.lblCod)
    .subscribe(res=>this.label=res);
  }
}
